module.exports = __webpack_public_path__ + "img/no-bookmarks.bd69979.png";